module.exports = __webpack_public_path__ + "img/two2.414f6fa5.png";